export default __webpack_public_path__ + "static/media/center5.35cf1c9e.jpg";